import Box from "@mui/material/Box";
import { useFormContext, FormProvider } from "react-hook-form";
import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import React, { useEffect, useState } from "react";
import {
  AD,
  ADD_PLATFORMS,
  ADS_CAMPAIGN_CAMPAIGN_INFORMATION_SUB_TITLE,
  BUTTON_CREATE_NEW,
  BUTTON_DELETE,
  BUTTON_DUPLICATE,
  BUTTON_DUPLICATE_IN_OTHER_AD_GROUP,
  BUTTON_DUPLICATE_IN_SAME_GROUP,
  COPY,
  GOOGLE_P_MAX,
  GOOGLE_SEARCH,
  GOOGLE_APP,
  THIS_ITEM_HAS_ERRORS,
  STATUS_FINISHED,
  DATE_SHORT_2,
  GO_TO_DASHBOARD,
  ALERT_DELETE_CAMPAIGN_TITLE,
  ALERT_DELETE_CAMPAIGN_ACTIVE_TITLE,
  ALERT_DELETE_CAMPAIGN_DESCRIPTION,
  ALERT_DELETE_CAMPAIGN_ERROR_TITLE,
  ALERT_DELETE_CAMPAIGN_ERROR_TEXT,
  ALERT_DELETE_ELEMENT_TITLE,
  ALERT_DELETE_ELEMENT_DESCRIPTION,
} from "../../../../i18n/keysTranslations";
import { capitalizeFirstLetter, logoPlatform } from "../../../../utils/string";
import { PRIMARY_COLOR } from "../../../../utils/colors";
import { useTranslationApp } from "../../../../lib/i18next";
import Avatar from "@mui/material/Avatar";
import { ChevronLeft, Layers } from "lucide-react";
import {
  ADS_CAMPAIGN_ENTITIES,
  ADS_CAMPAIGN_STATUS_DRAFT,
  ADS_CAMPAIGN_STATUS_ACTIVE,
  ADS_CAMPAIGN_STATUS_DEACTIVATED,
  ADS_CAMPAIGN_STATUS_DELETED,
  ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_OPTION,
  ADS_CAMPAIGN_TYPE_SEARCH_OPTION,
  ADS_CAMPAIGN_TYPE_APP_OPTION,
  ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION,
  GOOGLE,
  META,
  TIKTOK,
  DRAWER_CAMPAIGN,
  FONT_SIZE_BUTTON,
  FONT_WEIGHT_BUTTON,
  ROUTE_CAMPAIGNS,
} from "../../../../utils/constants";
import { useRebrandBanner } from "../../../../hooks/useRebrandBanner";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "../../../../components/Buttons/IconButton";
import {
  Drawer,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import { getKeyDatabase } from "../../../../services/public";
import { useDispatchApp, useSelectorApp } from "../../../../lib/redux";
import _ from "lodash";
import {
  ConfirmAlert,
  SimpleAlert,
} from "../../../../components/Alerts/Alerts";
import {
  startGetAdsCampaign,
  startSaveAdsCampaignDraft,
  startUpdateCampaignEntityStatus,
} from "../../../../actions/adsCampaigns";
import { setOpenSlideMenu } from "../../../../actions/ui";
import SwitchStatusItem from "../Common/SwitchStatusItem";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import { waitDelay } from "../../../../utils/date";
import {
  getAdGroupStructure,
  getAdStructure,
  getAssetsGroupStructure,
} from "../../../../services/adsCampaigns";
import { Link, useNavigate } from "react-router-dom";
import i18next from "i18next";
import { keyframes } from "@emotion/react";
import AddPlatformsCampaign from "../Setup/AddPlatformsCampaign";
import Loader from "../../../../components/Loaders/Loader";
import AdMediaPreviewIcon from "../../../../components/Common/AdMediaPreviewIcon";
import ModalDuplicateAdToAdGroup from "../../../../components/Modal/ModalDuplicateAdToAdGroup/ModalDuplicateAdToAdGroup";

const commonSxText = {
  fontSize: "14px",
  wordBreak: "break-word",
};

const commonSxIcon = {
  minWidth: "unset",
  color: PRIMARY_COLOR,
  ".MuiSvgIcon-root ": {
    width: 20,
    height: 20,
  },
};
const commonSx = {
  pr: 0.5,
  pl: 0,
  pt: 0.5,
  pb: 0.5,
  display: "flex",
  alignItems: "center",
  gap: 1,
  fontSize: "14px",
  height: 50,
};

const sxCutText = {
  whiteSpace: "normal",
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  WebkitLineClamp: 1,
  lineHeight: "1.2",
  WebkitBoxOrient: "vertical",
  wordBreak: "break-all",
};

const getTitlePlatform = ({ platform, objective }) => {
  if (objective === ADS_CAMPAIGN_TYPE_SEARCH_OPTION)
    return i18next.t(GOOGLE_SEARCH);
  if (objective === ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_OPTION)
    return i18next.t(GOOGLE_P_MAX);
  if (objective === ADS_CAMPAIGN_TYPE_APP_OPTION) return i18next.t(GOOGLE_APP);

  return i18next.t(ADS_CAMPAIGN_CAMPAIGN_INFORMATION_SUB_TITLE, {
    platform: capitalizeFirstLetter(i18next.t(platform)),
  });
};

// Wrapper component that manages local loading state for each switch
const SwitchStatusItemWrapper = ({ selectedSection, ...props }) => {
  const [isUpdatingLocal, setIsUpdatingLocal] = useState(false);
  const formContext = useFormContext();
  const { onChangeStatusCampaign } = formContext;

  const onChangeStatusCampaignWrapper = async (params) => {
    setIsUpdatingLocal(true);
    try {
      const result = await onChangeStatusCampaign(params);
      return result;
    } catch (error) {
      console.error("Error updating status:", error);
      throw error;
    } finally {
      setIsUpdatingLocal(false);
    }
  };

  const customFormContext = {
    ...formContext,
    onChangeStatusCampaign: onChangeStatusCampaignWrapper,
    isUpdating: false,
  };

  return (
    <FormProvider {...customFormContext}>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          ...props.sx,
        }}
      >
        {isUpdatingLocal ? (
          <Loader size={20} hasMarginTop={false} />
        ) : (
          <SwitchStatusItem selectedSection={selectedSection} {...props} />
        )}
      </Box>
    </FormProvider>
  );
};

const Sidebar = () => {
  const [isDeletingPlatform, setIsDeletingPlatform] = useState({
    isDeleting: false,
    platform: null,
  });
  const [deletingItems, setDeletingItems] = useState([]);
  const [anchorElMenu, setAnchorElMenu] = useState(null);
  const [selectedLevelMenu, setSelectedLevelMenu] = useState(null);
  const openMenu = Boolean(anchorElMenu);
  const [isSaving] = useState(false);
  const [isLastItem, setIsLastItem] = useState(false);

  const {
    watch,
    sectionSelected,
    onChangeSectionSelected,
    platformGenerating,
    onGetItemSelectedLevel,
    levelSectionSelected,
    getShowActionsPlatform,
    isGeneralDisabledFields,
    getValues,
    formState: { errors },
  } = useFormContext();

  const dispatch = useDispatchApp();
  const { slideMenuIsOpen } = useSelectorApp((state) => state.ui);
  const { showBanner } = useRebrandBanner();

  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("md"));

  const platformsData = watch("platformsData") || {};
  const platforms = Object.keys(platformsData);
  const adsGroups = watch("adsGroups") || [];
  const assetsGroups = watch("assetsGroups") || [];

  const { t } = useTranslationApp();

  const onSidebarItemClick = (sectionData) => {
    onChangeSectionSelected(sectionData);
    if (isMobile && slideMenuIsOpen) {
      dispatch(setOpenSlideMenu(false));
    }
  };

  const getIsFinished = ({ platform }) => {
    const currentDate = new Date();

    if (platform === GOOGLE) {
      const platformData = platformsData[platform] || {};
      const endDate = platformData.endDate;

      if (endDate) {
        const endDateTime = new Date(endDate);
        return endDateTime < currentDate
          ? { finished: true, date: endDate }
          : false;
      }
      return false;
    }

    if (platform === META || platform === TIKTOK) {
      const platformAdsGroups = adsGroups.filter(
        (adGroup) => adGroup.platform === platform
      );
      const finishedAdGroups = platformAdsGroups.filter((adGroup) => {
        const endDate = adGroup.endDate;
        const typeBudget = adGroup.typeBudget;

        return (
          endDate &&
          typeBudget === ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION &&
          new Date(endDate) < currentDate
        );
      });

      // Check if all ad groups are finished
      if (
        finishedAdGroups.length === platformAdsGroups.length &&
        platformAdsGroups.length > 0
      ) {
        // Find the most recent end date
        const mostRecentDate = finishedAdGroups.reduce(
          (mostRecent, adGroup) => {
            const currentDate = new Date(adGroup.endDate);
            return currentDate > mostRecent ? currentDate : mostRecent;
          },
          new Date(finishedAdGroups[0].endDate)
        );
        return { finished: true, date: mostRecentDate.getTime() };
      }
    }

    return false;
  };

  const getFinishedText = ({ platform }) => {
    const finishedInfo = getIsFinished({ platform });

    if (finishedInfo && finishedInfo.finished) {
      const formattedDate = t(DATE_SHORT_2, {
        date: new Date(finishedInfo.date),
      });
      return `${t(STATUS_FINISHED)}: ${formattedDate}`;
    }

    return null;
  };

  useEffect(() => {
    if (sectionSelected) {
      const scrollToSelectedItem = () => {
        let selector = '[data-testid="sidebar-item"]';

        if (sectionSelected.platform) {
          selector += `[data-platform="${sectionSelected.platform}"]`;

          if (sectionSelected.assetsGroupID) {
            selector += `[data-assetsgroup-id="${sectionSelected.assetsGroupID}"]`;
          }

          if (sectionSelected.adGroupID) {
            selector += `[data-adgroup-id="${sectionSelected.adGroupID}"]`;

            if (sectionSelected.adID) {
              selector += `[data-ad-id="${sectionSelected.adID}"]`;
            }
          }
        }

        const element = document.querySelector(selector);

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      };

      setTimeout(scrollToSelectedItem, 100);
    }
  }, [sectionSelected]);

  const getIsSelectedItem = ({ platform, assetsGroupID, adGroupID, adID }) => {
    const itemLevel = onGetItemSelectedLevel({
      platform,
      assetsGroupID,
      adGroupID,
      adID,
    });
    let isSelected = false;

    if (itemLevel && itemLevel === levelSectionSelected) {
      if (itemLevel === "platform") {
        isSelected = sectionSelected.platform === platform;
      } else if (itemLevel === "assetsGroup") {
        isSelected =
          sectionSelected.platform === platform &&
          sectionSelected.assetsGroupID === assetsGroupID;
      } else if (itemLevel === "adGroup") {
        isSelected =
          sectionSelected.platform === platform &&
          sectionSelected.adGroupID === adGroupID;
      } else if (itemLevel === "ad") {
        isSelected =
          sectionSelected.platform === platform &&
          sectionSelected.adGroupID === adGroupID &&
          sectionSelected.adID === adID;
      }
    }

    return isSelected;
  };

  const groupedAdGroups = adsGroups.reduce((acc, adGroup) => {
    const platform = adGroup.platform;
    if (!acc[platform]) {
      acc[platform] = [];
    }
    acc[platform].push(adGroup);
    return acc;
  }, {});

  const groupedAssetsGroups = assetsGroups.reduce((acc, assetsGroup) => {
    const platform = assetsGroup.platform;
    if (!acc[platform]) {
      acc[platform] = [];
    }
    acc[platform].push(assetsGroup);
    return acc;
  }, {});

  const onClickMenu = ({ event, selectedLevel, isLastItem }) => {
    setAnchorElMenu(event.currentTarget);
    setSelectedLevelMenu(selectedLevel);
    setIsLastItem(isLastItem);
  };
  const onOpenActionsMenu = ({ event, selectedLevel, isLastItem }) => {
    event.preventDefault();
    event.stopPropagation();
    onClickMenu({
      event,
      selectedLevel,
      isLastItem,
    });
  };
  const onCloseMenu = () => {
    setAnchorElMenu(null);
    setSelectedLevelMenu(null);
    setIsLastItem(false);
  };

  const onGetLevelHasError = ({ platform, assetsGroupID, adGroupID, adID }) => {
    const itemLevel = onGetItemSelectedLevel({
      platform,
      assetsGroupID,
      adGroupID,
      adID,
    });

    // First, check for traditional errors
    if (itemLevel === "platform") {
      if (errors?.platformsData?.[platform])
        return { hasError: true, errorType: "form" };
    }

    if (itemLevel === "assetsGroup") {
      const assetsGroupIndex = assetsGroups.findIndex(
        (assetsGroup) => assetsGroup.id === assetsGroupID
      );
      if (errors?.assetsGroups?.[assetsGroupIndex])
        return { hasError: true, errorType: "form" };
    }

    if (itemLevel === "adGroup") {
      const adGroupIndex = adsGroups.findIndex(
        (adGroup) => adGroup.id === adGroupID
      );
      if (errors?.adsGroups?.[adGroupIndex]) {
        const errorsKeys = Object.keys(errors?.adsGroups?.[adGroupIndex]);

        if (errorsKeys.length === 1 && errorsKeys[0] === "ads")
          return { hasError: false };

        return { hasError: true, errorType: "form" };
      }
    }

    if (itemLevel === "ad") {
      const adGroupIndex = adsGroups.findIndex(
        (adGroup) => adGroup.id === adGroupID
      );
      const adIndex = adsGroups[adGroupIndex]?.ads?.findIndex(
        (ad) => ad.id === adID
      );

      if (errors?.adsGroups?.[adGroupIndex]?.ads?.[adIndex])
        return { hasError: true, errorType: "form" };
    }

    // Then check for alerts based on IDs
    const hasAlert = onGetLevelHasAlert({
      platform,
      assetsGroupID,
      adGroupID,
      adID,
    });
    return hasAlert
      ? { hasError: true, errorType: "alert" }
      : { hasError: false };
  };

  const onGetLevelHasAlert = ({ platform, assetsGroupID, adGroupID, adID }) => {
    const platformsData = watch("platformsData") || {};
    const platformData = platformsData[platform];

    if (!platformData?.alerts || !Array.isArray(platformData.alerts)) {
      return false;
    }

    const itemLevel = onGetItemSelectedLevel({
      platform,
      assetsGroupID,
      adGroupID,
      adID,
    });

    // Check for alerts that match the provided IDs
    return platformData.alerts.some((alert) => {
      if (alert.adID) {
        return (
          itemLevel === "ad" &&
          alert.adID === adID &&
          alert.adGroupID === adGroupID
        );
      }

      if (alert.adGroupID) {
        return (
          itemLevel === "adGroup" && alert.adGroupID === adGroupID && !adID
        );
      }

      if (alert.assetsGroupID) {
        return (
          itemLevel === "assetsGroup" &&
          alert.assetsGroupID === assetsGroupID &&
          !adGroupID &&
          !adID
        );
      }

      return (
        itemLevel === "platform" &&
        !alert.adGroupID &&
        !alert.assetsGroupID &&
        !alert.adID
      );
    });
  };

  return (
    <Drawer
      open={isMobile ? slideMenuIsOpen : true}
      variant={isMobile ? "temporary" : "permanent"}
      anchor="left"
      data-tour="navigation"
      onClose={() => dispatch(setOpenSlideMenu(false))}
      ModalProps={{
        keepMounted: true,
      }}
      sx={{
        width: DRAWER_CAMPAIGN,
        "& .MuiDrawer-paper": {
          width: DRAWER_CAMPAIGN,
          boxSizing: "border-box",
          backgroundColor: "fields.background",
          borderRight: "1px solid #e5e5e5 !important",
          color: "background.paperContrastText",
          backgroundImage: "none",
          "&.MuiPaper-root": {
            overflowX: "hidden",
            borderRight: "none",
          },
        },
      }}
    >
      <Box
        sx={{
          width: "15%",
          pt: showBanner ? 5 : 1,
          minWidth: DRAWER_CAMPAIGN,
          height: "100%",
          overflow: "auto",
          pb: 15,
        }}
      >
        <List
          component="nav"
          subheader={
            !isMobile ? (
              <Link
                to={ROUTE_CAMPAIGNS}
                style={{
                  display: "flex",
                  width: "65%",
                  justifyContent: "flex-start",
                  textDecoration: "none",
                  color: "inherit",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    ml: "18px",
                    mt: 2.5,
                    mb: 2,
                  }}
                >
                  <ChevronLeft size={20} color={PRIMARY_COLOR} />
                  <Typography
                    sx={{
                      fontSize: FONT_SIZE_BUTTON,
                      fontWeight: FONT_WEIGHT_BUTTON,
                    }}
                  >
                    {t(GO_TO_DASHBOARD)}
                  </Typography>
                </Box>
              </Link>
            ) : null
          }
        >
          {platforms.map((platform) => {
            const isPlatformGenerating = platformGenerating === platform;
            const showAssetsGroupActions = true;
            const showAdGroupActions = true;
            const showAdActions = true;

            const isDeletingPlatformItem =
              isDeletingPlatform.platform === platform &&
              isDeletingPlatform.isDeleting;

            const isIncompatiblePlatform =
              getValues(`platformsData.${platform}.isIncompatible`) ||
              isGeneralDisabledFields;

            const assetsGroups = groupedAssetsGroups[platform] || [];
            const adGroups = groupedAdGroups[platform] || [];
            if (isPlatformGenerating) return null;

            const platformObjectSelection = {
              platform,
              assetsGroupID: undefined,
              adGroupID: undefined,
              adID: undefined,
            };

            const isSelectedPlatform = getIsSelectedItem(
              platformObjectSelection
            );

            const showActionsPlatform = getShowActionsPlatform(platform);
            const errorInfoPlatform = onGetLevelHasError(
              platformObjectSelection
            );

            const isLastPlatform = platforms.length === 1;

            const showDeleteActionPlatform =
              !isPlatformGenerating &&
              !isIncompatiblePlatform &&
              !isLastPlatform;

            return (
              <React.Fragment key={platform}>
                <ListItemButton
                  data-testid="sidebar-item"
                  data-platform={platform}
                  onClick={() => {
                    onSidebarItemClick(platformObjectSelection);
                  }}
                  sx={{
                    ...commonSx,
                    pl: 2,
                  }}
                >
                  {isSelectedPlatform && <LinearSelected />}
                  <ListItemIcon sx={commonSxIcon}>
                    <Avatar
                      alt={platform}
                      src={logoPlatform(platform)}
                      variant="square"
                      sx={{
                        width: 20,
                        height: 20,
                        ".MuiAvatar-img": {
                          objectFit: "contain",
                        },
                      }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    sx={{
                      mt: 0.75,
                      pr: 2,
                      ".MuiTypography-root": {
                        ...commonSxText,
                      },
                    }}
                    primary={
                      <Box
                        sx={{
                          width: "100%",
                        }}
                      >
                        <Box>
                          {getTitlePlatform({
                            platform,
                            objective: platformsData[platform]?.objective,
                          })}
                        </Box>
                        {getFinishedText({ platform }) && (
                          <Box
                            sx={{ fontSize: "12px", color: "text.secondary" }}
                          >
                            {getFinishedText({ platform })}
                          </Box>
                        )}
                      </Box>
                    }
                  />
                  {errorInfoPlatform.hasError && <ErrorIcon />}
                  {showActionsPlatform && (
                    <SwitchStatusItemWrapper
                      hasLabel={false}
                      selectedSection={platformObjectSelection}
                      sx={{ width: 30, mr: showDeleteActionPlatform ? 0 : 1 }}
                    />
                  )}
                  {showDeleteActionPlatform && (
                    <>
                      {isDeletingPlatformItem ? (
                        <Loader
                          size={20}
                          hasMarginTop={false}
                          sx={{
                            mr: "12px",
                            ml: "-4px",
                          }}
                        />
                      ) : (
                        <IconButton
                          edge="start"
                          onMouseDown={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                          }}
                          onClick={(event) => {
                            onOpenActionsMenu({
                              event,
                              selectedLevel: platformObjectSelection,
                            });
                          }}
                        >
                          <MoreHorizIcon />
                        </IconButton>
                      )}
                    </>
                  )}
                </ListItemButton>
                {isPlatformGenerating && <SkeletonGenerating />}
                {assetsGroups.map((assetsGroup) => {
                  const assetsGroupObjectSelection = {
                    platform,
                    assetsGroupID: assetsGroup.id,
                    adGroupID: undefined,
                    adID: undefined,
                  };

                  const isIncompatibleAssetsGroup =
                    isGeneralDisabledFields ||
                    isIncompatiblePlatform ||
                    assetsGroup.isIncompatible;

                  const isSelectedAssetsGroup = getIsSelectedItem(
                    assetsGroupObjectSelection
                  );

                  const errorInfoAssetsGroup = onGetLevelHasError(
                    assetsGroupObjectSelection
                  );

                  const isLastAssetsGroup = assetsGroups.length === 1;

                  return (
                    <ListItemButton
                      key={assetsGroup.id}
                      data-testid="sidebar-item"
                      data-platform={platform}
                      data-assetsgroup-id={assetsGroup.id}
                      onClick={() => {
                        onSidebarItemClick(assetsGroupObjectSelection);
                      }}
                      sx={{
                        ...commonSx,
                        pl: 4,
                      }}
                    >
                      {isSelectedAssetsGroup && <LinearSelected />}
                      <ListItemIcon sx={commonSxIcon}>
                        <Layers size={20} />
                      </ListItemIcon>
                      <Tooltip title={assetsGroup.name}>
                        <ListItemText
                          sx={{
                            width: "100%",
                            pr: 2,
                            ...commonSxText,
                            ".MuiTypography-root": {
                              ...commonSxText,
                              ...sxCutText,
                            },
                          }}
                          primary={assetsGroup.name}
                        />
                      </Tooltip>
                      {errorInfoAssetsGroup.hasError && <ErrorIcon />}
                      {deletingItems.includes(
                        `assetsGroup-${assetsGroup.id}`
                      ) ? (
                        <Loader
                          size={20}
                          hasMarginTop={false}
                          sx={{
                            mr: 1,
                          }}
                        />
                      ) : (
                        <>
                          {showActionsPlatform &&
                            assetsGroup.status !==
                              ADS_CAMPAIGN_STATUS_DRAFT && (
                              <SwitchStatusItemWrapper
                                hasLabel={false}
                                selectedSection={assetsGroupObjectSelection}
                                sx={{
                                  width: 30,
                                  mr: showAssetsGroupActions ? 0 : 4.5,
                                }}
                              />
                            )}
                          {showAssetsGroupActions &&
                            !isIncompatibleAssetsGroup && (
                              <IconButton
                                edge="start"
                                onMouseDown={(event) => {
                                  event.preventDefault();
                                  event.stopPropagation();
                                }}
                                onClick={(event) => {
                                  onOpenActionsMenu({
                                    event,
                                    selectedLevel: assetsGroupObjectSelection,
                                    isLastItem: isLastAssetsGroup,
                                  });
                                }}
                              >
                                <MoreHorizIcon />
                              </IconButton>
                            )}
                        </>
                      )}
                    </ListItemButton>
                  );
                })}
                {!isPlatformGenerating &&
                  adGroups.map((adGroup) => {
                    const adGroupObjectSelection = {
                      platform,
                      adGroupID: adGroup.id,
                      adID: undefined,
                    };

                    const isIncompatibleAdGroup =
                      isGeneralDisabledFields ||
                      isIncompatiblePlatform ||
                      adGroup.isIncompatible;

                    const isSelectedAdGroup = getIsSelectedItem(
                      adGroupObjectSelection
                    );

                    const errorInfoAdGroup = onGetLevelHasError(
                      adGroupObjectSelection
                    );

                    const isLastAdGroup = adGroups.length === 1;

                    const isDynamicCreativeMeta =
                      platform === META && adGroup?.isDynamicCreative;

                    return (
                      <React.Fragment key={adGroup.id}>
                        <ListItemButton
                          key={adGroup.id}
                          data-testid="sidebar-item"
                          data-platform={platform}
                          data-adgroup-id={adGroup.id}
                          onClick={() => {
                            onSidebarItemClick(adGroupObjectSelection);
                          }}
                          sx={{
                            ...commonSx,
                            pl: 4,
                          }}
                        >
                          {isSelectedAdGroup && <LinearSelected />}
                          <ListItemIcon sx={commonSxIcon}>
                            <Layers size={20} />
                          </ListItemIcon>
                          <Tooltip title={adGroup.name}>
                            <ListItemText
                              sx={{
                                width: "100%",
                                pr: 2,
                                ...commonSxText,
                                ".MuiTypography-root": {
                                  ...commonSxText,
                                  ...sxCutText,
                                },
                              }}
                              primary={adGroup.name}
                            />
                          </Tooltip>
                          {errorInfoAdGroup.hasError && <ErrorIcon />}
                          {deletingItems.includes(`adGroup-${adGroup.id}`) ? (
                            <Loader
                              size={20}
                              hasMarginTop={false}
                              sx={{
                                mr: 1,
                              }}
                            />
                          ) : (
                            <>
                              {showActionsPlatform &&
                                adGroup.status !==
                                  ADS_CAMPAIGN_STATUS_DRAFT && (
                                  <SwitchStatusItemWrapper
                                    hasLabel={false}
                                    selectedSection={adGroupObjectSelection}
                                    sx={{
                                      width: 30,
                                      mr: showAdGroupActions ? 0 : 4.5,
                                    }}
                                  />
                                )}
                              {showAdGroupActions && !isIncompatibleAdGroup && (
                                <IconButton
                                  edge="start"
                                  onMouseDown={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                  }}
                                  onClick={(event) => {
                                    onOpenActionsMenu({
                                      event,
                                      selectedLevel: adGroupObjectSelection,
                                      isLastItem: isLastAdGroup,
                                    });
                                  }}
                                >
                                  <MoreHorizIcon />
                                </IconButton>
                              )}
                            </>
                          )}
                        </ListItemButton>
                        {adGroup.ads &&
                          adGroup.ads.map((ad, indexAd) => {
                            const adObjectSelection = {
                              platform,
                              adGroupID: adGroup.id,
                              adID: ad.id,
                            };

                            const isIncompatibleAd =
                              isGeneralDisabledFields ||
                              isIncompatiblePlatform ||
                              isIncompatibleAdGroup ||
                              ad.isIncompatible;

                            const isSelectedAd =
                              getIsSelectedItem(adObjectSelection);

                            const errorInfoAd =
                              onGetLevelHasError(adObjectSelection);

                            const isLastAd = adGroup.ads.length === 1;

                            return (
                              <ListItemButton
                                data-testid="sidebar-item"
                                data-platform={platform}
                                data-adgroup-id={adGroup.id}
                                data-ad-id={ad.id}
                                onClick={() => {
                                  onSidebarItemClick(adObjectSelection);
                                }}
                                key={ad.id}
                                sx={{
                                  ...commonSx,
                                  pl: 8,
                                }}
                              >
                                {isSelectedAd && <LinearSelected />}
                                <ListItemIcon sx={commonSxIcon}>
                                  <AdMediaPreviewIcon
                                    mediaUrls={ad?.mediaUrls}
                                    size={20}
                                  />
                                </ListItemIcon>
                                <Tooltip
                                  title={ad.name || `${t(AD)} ${indexAd + 1}`}
                                >
                                  <ListItemText
                                    primary={
                                      ad.name || `${t(AD)} ${indexAd + 1}`
                                    }
                                    sx={{
                                      width: "100%",
                                      pr: 2,
                                      pl: 1,
                                      ".MuiTypography-root": {
                                        ...commonSxText,
                                        ...sxCutText,
                                      },
                                    }}
                                  />
                                </Tooltip>
                                {errorInfoAd.hasError && <ErrorIcon />}
                                {deletingItems.includes(
                                  `ad-${adGroup.id}-${ad.id}`
                                ) ? (
                                  <Loader
                                    size={20}
                                    hasMarginTop={false}
                                    sx={{
                                      mr: 1,
                                    }}
                                  />
                                ) : (
                                  <>
                                    {showActionsPlatform &&
                                      ad.status !==
                                        ADS_CAMPAIGN_STATUS_DRAFT && (
                                        <SwitchStatusItemWrapper
                                          hasLabel={false}
                                          selectedSection={adObjectSelection}
                                          sx={{
                                            width: 30,
                                            mr: showAdActions
                                              ? isDynamicCreativeMeta
                                                ? 3.05
                                                : 0
                                              : 4.5,
                                          }}
                                        />
                                      )}
                                    {showAdActions &&
                                      !isIncompatibleAd &&
                                      !isDynamicCreativeMeta && (
                                        <IconButton
                                          edge="start"
                                          onMouseDown={(event) => {
                                            event.preventDefault();
                                            event.stopPropagation();
                                          }}
                                          onClick={(event) => {
                                            onOpenActionsMenu({
                                              event,
                                              selectedLevel: adObjectSelection,
                                              isLastItem: isLastAd,
                                            });
                                          }}
                                        >
                                          <MoreHorizIcon />
                                        </IconButton>
                                      )}
                                  </>
                                )}
                              </ListItemButton>
                            );
                          })}
                      </React.Fragment>
                    );
                  })}
              </React.Fragment>
            );
          })}
        </List>
        <MenuOptions
          anchorEl={anchorElMenu}
          selectedLevel={selectedLevelMenu}
          open={openMenu}
          onCloseMenu={onCloseMenu}
          isLastItem={isLastItem}
          onCallbackDeletePlatform={({ platform, isDeleting }) => {
            setIsDeletingPlatform({
              isDeleting,
              platform,
            });
          }}
          onCallbackDeleteItem={({ itemKey, isDeleting }) => {
            setDeletingItems((prev) =>
              isDeleting
                ? [...prev, itemKey]
                : prev.filter((k) => k !== itemKey)
            );
          }}
        />
      </Box>

      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: DRAWER_CAMPAIGN,
          display: "flex",
          flexDirection: "column",
          gap: 1,
          py: 2.5,
          px: 2,
          backgroundColor: "fields.background",
          borderTop: "1px solid #e5e5e5 !important",
          borderRight: "1px solid #e5e5e5 !important",
        }}
      >
        <AddPlatformsCampaign
          typeView="sidebar"
          label={ADD_PLATFORMS}
          disabledButtons={isSaving || isGeneralDisabledFields}
          filterPlatforms={platforms}
          sxButtons={{
            px: 4,
            height: 56,
            maxHeight: "unset",
          }}
        />
      </Box>
    </Drawer>
  );
};

const blink = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
`;

const ErrorIcon = () => {
  const { t } = useTranslationApp();

  return (
    <Tooltip title={t(THIS_ITEM_HAS_ERRORS)}>
      <PriorityHighIcon
        sx={{
          color: "error.main",
          fontSize: 20,
          animation: `${blink} 1s infinite`,
        }}
      />
    </Tooltip>
  );
};

const SkeletonGenerating = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      {[1, 2, 3, 4].map((index) => (
        <Skeleton
          key={index}
          variant="rounded"
          sx={{
            height: 40,
            ml: 1,
            mr: 1,
          }}
        />
      ))}
    </Box>
  );
};

const MenuOptions = ({
  anchorEl,
  selectedLevel = {},
  open,
  onCloseMenu,
  isLastItem,
  onCallbackDeletePlatform = () => {},
  onCallbackDeleteItem = () => {},
}) => {
  const {
    onGetItemSelectedLevel,
    getValues,
    setValue,
    sectionSelected,
    onChangeSectionSelected,
    campaignID,
    onChangeStatusCampaign,
    onSaveAdsCampaignDraftWithApproval,
  } = useFormContext();

  const itemLevel = onGetItemSelectedLevel({
    platform: selectedLevel?.platform,
    assetsGroupID: selectedLevel?.assetsGroupID,
    adGroupID: selectedLevel?.adGroupID,
    adID: selectedLevel?.adID,
  });

  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const navigate = useNavigate();
  const [anchorElDuplicateMenu, setAnchorElDuplicateMenu] = useState(null);
  const [openDuplicateAdModal, setOpenDuplicateAdModal] = useState(false);
  const [duplicateTargetContext, setDuplicateTargetContext] = useState(null);
  const openDuplicateMenu = Boolean(anchorElDuplicateMenu);
  const currentCampaignID = campaignID || getValues("id");
  const currentDuplicatePlatform =
    duplicateTargetContext?.platform || selectedLevel?.platform;
  const currentCampaignName =
    getValues(`platformsData.${currentDuplicatePlatform}.name`) ||
    getValues("name");

  const onCloseDuplicateMenu = () => {
    setAnchorElDuplicateMenu(null);
  };

  const onCloseAllMenus = () => {
    onCloseDuplicateMenu();
    onCloseMenu();
  };

  const onDeletePlatform = async () => {
    const platform = selectedLevel?.platform;
    const states = getValues("states") || {};
    const platformStatus = states[platform];
    const isActive = platformStatus === ADS_CAMPAIGN_STATUS_ACTIVE;

    const result = await ConfirmAlert({
      title: isActive
        ? t(ALERT_DELETE_CAMPAIGN_ACTIVE_TITLE)
        : t(ALERT_DELETE_CAMPAIGN_TITLE),
      text: t(ALERT_DELETE_CAMPAIGN_DESCRIPTION, {
        platform: capitalizeFirstLetter(platform),
      }),
      confirmButtonText: t(BUTTON_DELETE),
    });

    if (!result.isConfirmed) return;

    if (isActive) {
      onCallbackDeletePlatform({
        isDeleting: true,
        platform,
      });
      const deactivationSuccess = await onChangeStatusCampaign({
        newStatus: ADS_CAMPAIGN_STATUS_DEACTIVATED,
        target: "platform",
        platform: platform,
      });
      onCallbackDeletePlatform({
        isDeleting: false,
        platform: null,
      });

      if (!deactivationSuccess) {
        SimpleAlert({
          title: t(ALERT_DELETE_CAMPAIGN_ERROR_TITLE),
          text: t(ALERT_DELETE_CAMPAIGN_ERROR_TEXT),
          icon: "error",
        });
        return;
      }

      const statusAfterDeactivate = getValues("states")?.[platform];

      if (statusAfterDeactivate === ADS_CAMPAIGN_STATUS_ACTIVE) {
        return;
      }
    }

    if (sectionSelected.platform === platform) {
      const platforms = getValues("platforms") || [];
      const platformsFiltered = platforms.filter((p) => p !== platform);
      onChangeSectionSelected({
        platform: platformsFiltered?.[0] || undefined,
        adGroupID: undefined,
        adID: undefined,
      });
    }

    const platforms = getValues("platforms");
    const newPlatforms = platforms.filter((p) => p !== platform);
    const platformsData = { ...getValues("platformsData") };
    const platformIDs = { ...(getValues("platformIDs") || {}) };
    const statistics = { ...(getValues("statistics") || {}) };
    const statesUpdated = { ...getValues("states") };
    const adsGroups = getValues("adsGroups") || [];
    const assetsGroups = getValues("assetsGroups") || [];

    delete platformsData[platform];
    delete statesUpdated[platform];
    delete platformIDs[platform];
    delete statistics[platform];

    const restStatesPlatforms = Object.keys(statesUpdated).filter(
      (p) => p !== "general"
    );
    const firstPlatformStatus = restStatesPlatforms?.[0];
    const newGeneralStatus = statesUpdated?.[firstPlatformStatus];
    if (newGeneralStatus) {
      statesUpdated.general = newGeneralStatus;
    }

    setValue("platforms", newPlatforms, { shouldDirty: true });
    setValue("platformsData", platformsData, { shouldDirty: true });
    setValue("states", statesUpdated, { shouldDirty: true });
    setValue("platformIDs", platformIDs, { shouldDirty: true });
    setValue("statistics", statistics, { shouldDirty: true });

    const newAdsGroups = adsGroups.filter(
      (adGroup) => adGroup.platform !== platform
    );
    setValue("adsGroups", newAdsGroups, { shouldDirty: true });

    const newAssetsGroups = assetsGroups.filter(
      (assetsGroup) => assetsGroup.platform !== platform
    );
    setValue("assetsGroups", newAssetsGroups, { shouldDirty: true });

    const campaignData = getValues();
    await onSaveAdsCampaignDraftWithApproval({
      campaign: campaignData,
      campaignID,
    });
  };

  const onAddAssetsGroup = async ({ platform }) => {
    const newAssetsGroupID = dispatch(getKeyDatabase());
    const newAssetsGroup = getAssetsGroupStructure({
      platform,
      campaignID,
      assetsGroupID: newAssetsGroupID,
    });

    const assetsGroups = getValues("assetsGroups");
    setValue(`assetsGroups`, [...assetsGroups, newAssetsGroup]);
    await waitDelay(500);

    onChangeSectionSelected({
      platform: selectedLevel.platform,
      assetsGroupID: newAssetsGroupID,
      adGroupID: undefined,
      adID: undefined,
    });
  };

  const onDuplicateAssetsGroup = async ({ assetsGroupID }) => {
    const assetsGroups = getValues("assetsGroups");
    const currentAssetsGroupToCopy = assetsGroups.find(
      (assetsGroup) => assetsGroup.id === assetsGroupID
    );

    if (!currentAssetsGroupToCopy) {
      console.error("Assets group not found");
      return;
    }

    const newAssetsGroupID = dispatch(getKeyDatabase());
    const newAssetsGroup = _.cloneDeep(currentAssetsGroupToCopy);
    newAssetsGroup.id = newAssetsGroupID;
    newAssetsGroup.name = `${newAssetsGroup.name} - ${t(COPY)}`;
    newAssetsGroup.status = ADS_CAMPAIGN_STATUS_DRAFT;
    delete newAssetsGroup.idPlatform;
    delete newAssetsGroup.titlesIDs;
    delete newAssetsGroup.longHeadlinesIDs;
    delete newAssetsGroup.descriptionsIDs;
    delete newAssetsGroup.businessNameID;
    delete newAssetsGroup.imageIDs;
    delete newAssetsGroup.videoIDs;
    delete newAssetsGroup.logoIDs;
    delete newAssetsGroup.searchThemesIDs;

    setValue(`assetsGroups`, [...assetsGroups, newAssetsGroup]);
    await waitDelay(500);

    onChangeSectionSelected({
      platform: selectedLevel.platform,
      assetsGroupID: newAssetsGroupID,
      adGroupID: undefined,
      adID: undefined,
    });
  };

  const onRemoveAssetsGroup = async ({ assetsGroupID }) => {
    const itemKey = `assetsGroup-${assetsGroupID}`;
    try {
      const assetsGroups = getValues("assetsGroups");
      const assetsGroup = assetsGroups.find((ag) => ag.id === assetsGroupID);

      if (assetsGroup?.status !== ADS_CAMPAIGN_STATUS_DRAFT) {
        const result = await ConfirmAlert({
          title: t(ALERT_DELETE_ELEMENT_TITLE),
          text: t(ALERT_DELETE_ELEMENT_DESCRIPTION, {
            platform: capitalizeFirstLetter(selectedLevel.platform),
          }),
          confirmButtonText: t(BUTTON_DELETE),
        });

        if (!result.isConfirmed) return;

        onCallbackDeleteItem({ itemKey, isDeleting: true });

        const response = await dispatch(
          startUpdateCampaignEntityStatus({
            campaignID,
            platform: selectedLevel.platform,
            entity: ADS_CAMPAIGN_ENTITIES.ASSETS_GROUP,
            entityID: assetsGroup.id,
            status: ADS_CAMPAIGN_STATUS_DELETED,
          })
        );

        if (!response.ok) {
          return;
        }
      }

      const newAssetsGroups = assetsGroups.filter(
        (ag) => ag.id !== assetsGroupID
      );
      setValue("assetsGroups", newAssetsGroups);

      if (sectionSelected.assetsGroupID === assetsGroupID) {
        onChangeSectionSelected({
          platform: selectedLevel.platform,
          assetsGroupID: undefined,
          adGroupID: undefined,
          adID: undefined,
        });
      } else {
        onChangeSectionSelected(sectionSelected);
      }
    } finally {
      onCallbackDeleteItem({ itemKey, isDeleting: false });
    }
  };

  const onAddGroup = async ({ platform, adGroupID }) => {
    const adsGroups = getValues("adsGroups");
    const currentAdGroup = adsGroups.find(
      (adGroup) => adGroup.id === adGroupID
    );
    const currentAds = currentAdGroup?.ads || [];

    const platformData = getValues(`platformsData.${platform}`);
    const objective = platformData?.objective;

    const destinationTypeAdGroup = currentAdGroup?.destinationType;
    const destinationTypeAd = currentAds?.[0]?.destinationType;

    const newGroupID = dispatch(getKeyDatabase());
    const newAdID = dispatch(getKeyDatabase());

    const newStructure = getAdGroupStructure({
      platform,
      campaignID,
      objective,
      adGroupID: newGroupID,
      adID: newAdID,
      forcedData: {
        adGroup: {
          destinationType: destinationTypeAdGroup,
        },
        ad: {
          destinationType: destinationTypeAd,
        },
      },
    });

    const newAdGroup = _.cloneDeep(newStructure);

    setValue(`adsGroups`, [...adsGroups, newAdGroup]);
    await waitDelay(500);

    onChangeSectionSelected({
      platform: selectedLevel.platform,
      adGroupID: newGroupID,
      adID: undefined,
    });
  };

  const onDuplicateAdGroup = async ({ adGroupID }) => {
    const newGroupID = dispatch(getKeyDatabase());

    const adsGroups = getValues("adsGroups");
    const currentAdGroupToCopy = adsGroups.find(
      (adGroup) => adGroup.id === adGroupID
    );

    if (!currentAdGroupToCopy) {
      console.error("Ad group not found");
      return;
    }

    const newAdGroup = _.cloneDeep(currentAdGroupToCopy);
    newAdGroup.id = newGroupID;
    newAdGroup.name = `${newAdGroup.name} - ${t(COPY)}`;
    newAdGroup.status = ADS_CAMPAIGN_STATUS_DRAFT;
    delete newAdGroup.idPlatform;
    delete newAdGroup.keywordsIDs;
    delete newAdGroup.keywordsNegativeIDs;
    delete newAdGroup.estimationID;

    if (!_.isEmpty(newAdGroup.ads)) {
      const newAds = newAdGroup.ads.map((ad) => {
        const newAd = _.cloneDeep(ad);
        const newAdID = dispatch(getKeyDatabase());
        newAd.id = newAdID;
        newAd.adGroupID = newGroupID;
        newAd.status = ADS_CAMPAIGN_STATUS_DRAFT;
        delete newAd.idPlatform;
        return newAd;
      });

      newAdGroup.ads = newAds;
    }

    setValue(`adsGroups`, [...adsGroups, newAdGroup]);
    await waitDelay(500);

    onChangeSectionSelected({
      platform: selectedLevel.platform,
      adGroupID: newGroupID,
      adID: undefined,
    });
  };

  const onRemoveAdGroup = async ({ adGroupID }) => {
    const itemKey = `adGroup-${adGroupID}`;
    try {
      const adsGroups = getValues("adsGroups");
      const adGroup = adsGroups.find((ag) => ag.id === adGroupID);

      if (adGroup?.status !== ADS_CAMPAIGN_STATUS_DRAFT) {
        const result = await ConfirmAlert({
          title: t(ALERT_DELETE_ELEMENT_TITLE),
          text: t(ALERT_DELETE_ELEMENT_DESCRIPTION, {
            platform: capitalizeFirstLetter(selectedLevel.platform),
          }),
          confirmButtonText: t(BUTTON_DELETE),
        });

        if (!result.isConfirmed) return;

        onCallbackDeleteItem({ itemKey, isDeleting: true });

        const response = await dispatch(
          startUpdateCampaignEntityStatus({
            campaignID,
            platform: selectedLevel.platform,
            entity: ADS_CAMPAIGN_ENTITIES.AD_GROUP,
            entityID: adGroup.id,
            status: ADS_CAMPAIGN_STATUS_DELETED,
          })
        );

        if (!response.ok) {
          return;
        }
      }

      const newAdsGroups = adsGroups.filter((ag) => ag.id !== adGroupID);

      if (sectionSelected.adGroupID === adGroupID) {
        onChangeSectionSelected({
          platform: selectedLevel.platform,
          adGroupID: undefined,
          adID: undefined,
        });
      } else {
        onChangeSectionSelected(sectionSelected);
      }

      setValue("adsGroups", newAdsGroups);
    } finally {
      onCallbackDeleteItem({ itemKey, isDeleting: false });
    }
  };

  const onAddAd = async ({ platform, adGroupID, adID }) => {
    const adsGroups = getValues("adsGroups");
    const adGroupIndex = adsGroups.findIndex(
      (adGroup) => adGroup.id === adGroupID
    );
    const currentAdGroup = getValues(`adsGroups.[${adGroupIndex}]`);
    const currentAds = getValues(`adsGroups.[${adGroupIndex}].ads`);
    const currentAdIndex = currentAds.findIndex((ad) => ad.id === adID);
    const currentAd = currentAds[currentAdIndex];
    const destinationType = currentAd.destinationType;
    const productSetID = currentAd.productSetID || "";
    const creativeSource = currentAd.creativeSource || "";
    const productSetIDAdGroup = currentAdGroup.productSetID || "";

    const newAdID = dispatch(getKeyDatabase());

    const newStructure = getAdStructure({
      platform,
      campaignID,
      adGroupID,
      adID: newAdID,
      forcedData: {
        ad: {
          destinationType,
          productSetID: productSetID || productSetIDAdGroup,
          creativeSource,
        },
      },
    });

    setValue(`adsGroups.[${adGroupIndex}].ads`, [...currentAds, newStructure]);
    await waitDelay(500);

    onChangeSectionSelected({
      platform,
      adGroupID: adGroupID,
      adID: newAdID,
    });
  };

  const getDuplicatedAd = ({ ad, targetAdGroupID }) => {
    const newAdID = dispatch(getKeyDatabase());
    const duplicatedAd = _.cloneDeep(ad);

    duplicatedAd.id = newAdID;
    duplicatedAd.adGroupID = targetAdGroupID;
    duplicatedAd.name = `${duplicatedAd.name} - ${t(COPY)}`;
    duplicatedAd.status = ADS_CAMPAIGN_STATUS_DRAFT;
    delete duplicatedAd.idPlatform;

    return {
      duplicatedAd,
      newAdID,
    };
  };

  const onDuplicateAd = async ({ adGroupID, adID }) => {
    const adGroups = getValues("adsGroups");
    const adGroupIndex = adGroups.findIndex(
      (adGroup) => adGroup.id === adGroupID
    );

    const currentAds = getValues(`adsGroups.[${adGroupIndex}].ads`);
    const adIndex = currentAds.findIndex((ad) => ad.id === adID);

    const currentAdToCopy = getValues(
      `adsGroups.[${adGroupIndex}].ads.[${adIndex}]`
    );
    if (!currentAdToCopy) {
      console.error("Ad not found");
      return;
    }

    const { duplicatedAd: newAd, newAdID } = getDuplicatedAd({
      ad: currentAdToCopy,
      targetAdGroupID: adGroupID,
    });

    setValue(`adsGroups.[${adGroupIndex}].ads`, [...currentAds, newAd]);
    await waitDelay(500);

    onChangeSectionSelected({
      platform: selectedLevel.platform,
      adGroupID: adGroupID,
      adID: newAdID,
    });
  };

  const onDuplicateAdInTargetGroup = async ({
    targetCampaignID,
    targetAdGroupID,
  }) => {
    const sourceContext = duplicateTargetContext || selectedLevel;
    if (
      !sourceContext?.adGroupID ||
      !sourceContext?.adID ||
      !sourceContext?.platform
    ) {
      console.error("Source duplicate context not found");
      return false;
    }

    const sourceAdGroups = getValues("adsGroups") || [];
    const sourceAdGroup = sourceAdGroups.find(
      (adGroup) => adGroup.id === sourceContext.adGroupID
    );
    const sourceAd = sourceAdGroup?.ads?.find(
      (ad) => ad.id === sourceContext.adID
    );

    if (!sourceAd) {
      console.error("Source ad not found");
      return false;
    }

    const { duplicatedAd, newAdID } = getDuplicatedAd({
      ad: sourceAd,
      targetAdGroupID,
    });

    if (targetCampaignID === currentCampaignID) {
      const targetAdGroupIndex = sourceAdGroups.findIndex(
        (adGroup) => adGroup.id === targetAdGroupID
      );

      if (targetAdGroupIndex === -1) {
        console.error("Target ad group not found in current campaign");
        return false;
      }

      const targetAds =
        getValues(`adsGroups.[${targetAdGroupIndex}].ads`) || [];
      setValue(`adsGroups.[${targetAdGroupIndex}].ads`, [
        ...targetAds,
        duplicatedAd,
      ]);
      await waitDelay(500);

      onChangeSectionSelected({
        platform: sourceContext.platform,
        adGroupID: targetAdGroupID,
        adID: newAdID,
      });

      return true;
    }

    const destinationCampaign = await dispatch(
      startGetAdsCampaign(targetCampaignID, true)
    );
    if (!destinationCampaign) {
      console.error("Destination campaign not found");
      return false;
    }

    const destinationAdGroups = destinationCampaign.adsGroups || [];
    const targetAdGroupIndex = destinationAdGroups.findIndex(
      (adGroup) => adGroup.id === targetAdGroupID
    );

    if (targetAdGroupIndex === -1) {
      console.error("Target ad group not found in destination campaign");
      return false;
    }

    const updatedDestinationCampaign = _.cloneDeep(destinationCampaign);
    const destinationTargetAds =
      updatedDestinationCampaign.adsGroups[targetAdGroupIndex].ads || [];
    updatedDestinationCampaign.adsGroups[targetAdGroupIndex].ads = [
      ...destinationTargetAds,
      duplicatedAd,
    ];

    const isSaved = await dispatch(
      startSaveAdsCampaignDraft({
        campaign: updatedDestinationCampaign,
        campaignID: targetCampaignID,
      })
    );

    if (!isSaved) {
      return false;
    }

    navigate(
      `/ads-campaign?campaignID=${targetCampaignID}&platform=${sourceContext.platform}&adGroupID=${targetAdGroupID}&adID=${newAdID}`
    );

    return true;
  };

  const onRemoveAd = async ({ adGroupID, adID }) => {
    const itemKey = `ad-${adGroupID}-${adID}`;
    try {
      const adsGroups = getValues("adsGroups");

      const adGroupIndex = adsGroups.findIndex(
        (adGroup) => adGroup.id === adGroupID
      );
      if (adGroupIndex === -1) {
        console.error("Ad group not found");
        return;
      }

      const ad = adsGroups[adGroupIndex].ads.find((a) => a.id === adID);

      if (!ad) {
        console.error("Ad not found");
        return;
      }

      if (ad.status !== ADS_CAMPAIGN_STATUS_DRAFT) {
        const result = await ConfirmAlert({
          title: t(ALERT_DELETE_ELEMENT_TITLE),
          text: t(ALERT_DELETE_ELEMENT_DESCRIPTION, {
            platform: capitalizeFirstLetter(selectedLevel.platform),
          }),
          confirmButtonText: t(BUTTON_DELETE),
        });

        if (!result.isConfirmed) return;

        onCallbackDeleteItem({ itemKey, isDeleting: true });

        const response = await dispatch(
          startUpdateCampaignEntityStatus({
            campaignID,
            platform: selectedLevel.platform,
            entity: ADS_CAMPAIGN_ENTITIES.AD,
            entityID: ad.id,
            status: ADS_CAMPAIGN_STATUS_DELETED,
          })
        );

        if (!response.ok) {
          return;
        }
      }

      if (sectionSelected.adID === adID) {
        onChangeSectionSelected({
          platform: selectedLevel.platform,
          adGroupID: adGroupID,
          adID: undefined,
        });
      } else {
        onChangeSectionSelected(sectionSelected);
      }
      const ads = getValues(`adsGroups.[${adGroupIndex}].ads`);
      const adIndex = ads.findIndex((a) => a.id === adID);
      const newAds = ads.filter((_, index) => index !== adIndex);
      setValue(`adsGroups.[${adGroupIndex}].ads`, newAds);
    } finally {
      onCallbackDeleteItem({ itemKey, isDeleting: false });
    }
  };

  const onExecuteAction = async (action) => {
    if (itemLevel === "platform" && action === "delete") {
      onDeletePlatform();
    }

    if (itemLevel === "assetsGroup" && action === "add") {
      onAddAssetsGroup({
        platform: selectedLevel.platform,
        assetsGroupID: selectedLevel.assetsGroupID,
      });
    }
    if (itemLevel === "assetsGroup" && action === "duplicate") {
      onDuplicateAssetsGroup({
        assetsGroupID: selectedLevel.assetsGroupID,
      });
    }
    if (itemLevel === "assetsGroup" && action === "delete") {
      await onRemoveAssetsGroup({
        assetsGroupID: selectedLevel.assetsGroupID,
      });
    }

    if (itemLevel === "adGroup" && action === "add") {
      onAddGroup({
        platform: selectedLevel.platform,
        adGroupID: selectedLevel.adGroupID,
      });
    }
    if (itemLevel === "adGroup" && action === "duplicate") {
      onDuplicateAdGroup({ adGroupID: selectedLevel.adGroupID });
    }
    if (itemLevel === "adGroup" && action === "delete") {
      await onRemoveAdGroup({ adGroupID: selectedLevel.adGroupID });
    }

    if (itemLevel === "ad" && action === "add") {
      onAddAd({
        platform: selectedLevel.platform,
        adGroupID: selectedLevel.adGroupID,
        adID: selectedLevel.adID,
      });
    }
    if (itemLevel === "ad" && action === "duplicate") {
      onDuplicateAd({
        adGroupID: selectedLevel.adGroupID,
        adID: selectedLevel.adID,
      });
    }
    if (itemLevel === "ad" && action === "delete") {
      await onRemoveAd({
        adGroupID: selectedLevel.adGroupID,
        adID: selectedLevel.adID,
      });
    }
  };

  const onOpenDuplicateSubMenu = (event) => {
    setAnchorElDuplicateMenu(event.currentTarget);
  };

  const onDuplicateInSameGroup = () => {
    onCloseAllMenus();
    onExecuteAction("duplicate");
  };

  const onDuplicateInOtherGroup = () => {
    setDuplicateTargetContext({
      platform: selectedLevel?.platform,
      adGroupID: selectedLevel?.adGroupID,
      adID: selectedLevel?.adID,
    });
    onCloseAllMenus();
    setOpenDuplicateAdModal(true);
  };

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => {
          onCloseAllMenus();
        }}
      >
        {itemLevel !== "platform" && (
          <MenuItem
            onClick={() => {
              onCloseAllMenus();
              onExecuteAction("add");
            }}
          >
            {t(BUTTON_CREATE_NEW)}
          </MenuItem>
        )}
        {itemLevel !== "platform" &&
          (itemLevel === "ad" ? (
            <MenuItem onClick={onOpenDuplicateSubMenu}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  gap: 1,
                }}
              >
                <Box>{t(BUTTON_DUPLICATE)}</Box>
                <KeyboardArrowRightIcon fontSize="small" />
              </Box>
            </MenuItem>
          ) : (
            <MenuItem
              onClick={() => {
                onCloseAllMenus();
                onExecuteAction("duplicate");
              }}
            >
              {t(BUTTON_DUPLICATE)}
            </MenuItem>
          ))}
        {(itemLevel === "platform" || !isLastItem) && (
          <MenuItem
            onClick={() => {
              onCloseAllMenus();
              onExecuteAction("delete");
            }}
          >
            {t(BUTTON_DELETE)}
          </MenuItem>
        )}
      </Menu>
      <Menu
        anchorEl={anchorElDuplicateMenu}
        open={itemLevel === "ad" && openDuplicateMenu}
        onClose={onCloseDuplicateMenu}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem onClick={onDuplicateInSameGroup}>
          {t(BUTTON_DUPLICATE_IN_SAME_GROUP)}
        </MenuItem>
        <MenuItem onClick={onDuplicateInOtherGroup}>
          {t(BUTTON_DUPLICATE_IN_OTHER_AD_GROUP)}
        </MenuItem>
      </Menu>
      {openDuplicateAdModal && (
        <ModalDuplicateAdToAdGroup
          modalOpen={openDuplicateAdModal}
          onCloseModal={() => {
            setOpenDuplicateAdModal(false);
            setDuplicateTargetContext(null);
          }}
          currentCampaignID={currentCampaignID}
          currentCampaignName={currentCampaignName}
          platform={currentDuplicatePlatform}
          currentCampaignAdGroups={getValues("adsGroups") || []}
          onConfirmDuplicate={onDuplicateAdInTargetGroup}
        />
      )}
    </>
  );
};

const LinearSelected = () => {
  return (
    <Box
      sx={{
        width: 5,
        height: 40,
        position: "absolute",
        background: "black",
        left: "1px",
      }}
    ></Box>
  );
};
export default Sidebar;
